import React, { ReactChild } from "react";
import { RichTextNode } from "wmk-rich-text";

const defaultblockHeading2 = (node: RichTextNode, children: ReactChild) => (
  <h2 className="body-copy-title">{children}</h2>
);

export default defaultblockHeading2;
